module.exports = __webpack_public_path__ + "media/components/country-flag/static/py-5879334c57ff786c2a817982dd9eb4a4.svg";